import { UserPermissions } from '@gasbi/shared';
import { makeSSOIntegrationsRoute as _makeSSOIntegrationsRoute } from '@gasbi/shared/web/SSOIntegrations';

import {
  useCreateSSOConfigurationMutation,
  useGetSSOConfigurationBySchemaQuery,
  useGetSSOConfigurationsQuery,
  useGetSSOSettingsQuery,
  useToggleSSOConfigurationMutation,
  useUpsetPartialSSOConfigurationMutation,
  useUpsetSSOConfigurationMutation,
} from '@/features/ssoIntegrations/ssoIntegrationsApi';

export const makeSSOIntegrationsRoute = () =>
  _makeSSOIntegrationsRoute({
    context: {
      api: {
        useGetSSOSettingsQuery,
        useGetSSOConfigurationsQuery,
        useGetSSOConfigurationBySchemaQuery,
        useCreateSSOConfigurationMutation,
        useUpsetSSOConfigurationMutation,
        useUpsetPartialSSOConfigurationMutation,
        useToggleSSOConfigurationMutation,
      },
      UserPermissions,
    },
  });
